export default "__VITE_ASSET__ItbUxZU1__"